import Component from 'flarum/common/Component';
import clsx from 'flarum/common/utils/classList';
export default class LabelGroup extends Component {
  view(vnode) {
    return m("span", {
      className: clsx('UiKit-LabelGroup', this.attrs.className)
    }, vnode.children);
  }
}
flarum.reg.add('fof-ui-kit', 'common/components/LabelGroup', LabelGroup);